export const LOGIN_USER = "LOGIN_USER"
export const RESET_USER_PASSWORD = "RESET_USER_PASSWORD"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"

export const LOGOUT_USER = "LOGOUT_USER"
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS"
export const API_ERROR = "LOGIN_API_ERROR"
export const RESET_USER_PASSWORD_SUCCESS = "RESET_USER_PASSWORD_SUCCESS"

export const SOCIAL_LOGIN = "SOCIAL_LOGIN"
